export const formatCurrencyValue = (value: any) => {
	return (
		"$" +
		parseFloat(value).toLocaleString("en-AU", {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		})
	);
};
